module.exports = __webpack_public_path__ + "first-5_signature.jpg?702efcb95edc5c4abaa3ece45ae89d0f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5_signature.jpg
// module id = 589
// module chunks = 0